import ProductFormSkeleton from "@/app/components/common/skeletons/ProductFormSkeleton";
import { useGetCategoriesQuery } from "@/lib/api/apiSlice";
import { useShowInitialLoader } from "@/lib/hooks";
import ProductForm from "@/app/components/seller/product/ProductForm";

const categoryRelations = [
  "subCategories",
  "subCategories.subSubCategories",
  "subCategories.subSubCategories.categoryAttributes",
  "subCategories.subSubCategories.categoryAttributes.attribute",
  "subCategories.subSubCategories.categoryAttributes.attribute.attributeDetails",
].join(",");

export default function AddProductPage() {
  const { data: categories, isLoading } = useGetCategoriesQuery({
    relations: categoryRelations,
  });
  const showLoader = useShowInitialLoader(isLoading, categories);

  if (showLoader) {
    return <ProductFormSkeleton />;
  }

  return <ProductForm categories={categories ?? []} selectedProduct={null} />;
}
